













































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Project } from '@/store/projects'
@Component
export default class ProjectComponent extends Vue {
  @Prop() project!: Project;

  private get eyecatch(){
    if(this.project.squareEyecatch) return 'background-image: url('+this.project.squareEyecatch+')';
    if(this.project.eyecatch) return 'background-image: url('+this.project.eyecatch+')';
    return '';
  }
}
